import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);
  const { search } = useLocation();
  const isPrint = new URLSearchParams(search).get("print") === "1";
  useEffect(() => {
    if (!isPrint && !localStorage.getItem("ao_cookie_ack")) setVisible(true);
  }, [isPrint]);
  if (isPrint || !visible) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 bg-[#FAFAF9] border border-[#1A1915] p-4" data-testid="cookie-notice">
      <div className="eyebrow mb-2">Notice</div>
      <p className="text-sm text-[#1A1915] leading-relaxed">
        We use minimal cookies to enable payment and access. Analytics events fire on purchase completion. No profile is built. US market only.
      </p>
      <div className="mt-3 flex gap-2">
        <button
          className="btn-primary text-xs"
          data-testid="cookie-ack-button"
          onClick={() => {
            localStorage.setItem("ao_cookie_ack", "1");
            setVisible(false);
          }}
        >
          Acknowledge
        </button>
      </div>
    </div>
  );
}
